/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'abort': 'Abbrechen',
    'absolute': 'absolut',
    'accept': 'Akzeptieren',
    'action': 'Aktion',
    'active': 'Aktiv',
    'add_textarea': 'Textbereich hinzufügen',
    'all': 'Alle',
    'apply': 'anwenden',
    'archive': 'Archivieren',
    'archived': 'Archiviert',
    'authorization_required': 'Bitte gib dein Passwort ein um die Änderung zu autorisieren.',
    'authorize': 'Autorisieren',
    'auto_generate': 'Automatisch generieren',
    'back': 'Zurück',
    'cancel': 'Abbrechen',
    'change_filter_options': 'Bitte versuche andere Filter',
    'change_selection': 'Auswahl ändern',
    'clear': 'Löschen',
    'click_to_edit': 'Klicken zum bearbeiten',
    'close': 'Schließen',
    'coming_soon': 'Bald verfügbar',
    'committed': 'Festgeschrieben',
    'complete': 'Abschließen',
    'confirm': 'Bestätigen',
    'contact_support': 'Support kontaktieren',
    'copied': 'Kopiert!',
    'copy': 'Kopieren',
    'copy_failed': 'Konnte nicht in die Zwischenablage kopieren',
    'create': 'Erstellen',
    'created_at': 'Erstellt vor',
    'creation_date': 'Erstellungsdatum',
    'day': 'Tag | Tage',
    'delete': 'Löschen',
    'deleted_user': 'Gelöschter Nutzer',
    'disable': 'Deaktivieren',
    'disabled': 'Deaktiviert',
    'display': 'Anzeigen',
    'dont_create': 'Nicht erstellen',
    'download': 'Download',
    'download_pdf': 'PDF herunterladen',
    'duplicate': 'Duplizieren',
    'edit': 'Bearbeiten',
    'email_to': 'An',
    'enable': 'Aktivieren',
    'enabled': 'Aktiviert',
    'end': 'Ende',
    'ends_at': 'Endet am {endsAt}',
    'export': 'Exportieren',
    'export_all': 'Alle Exportieren',
    'export_selected': 'Ausgewählte Exportieren',
    'export_successful_body': 'Wir senden dir eine E-Mail sobald der Export abgeschlossen ist',
    'export_successful_title': 'Export gestartet',
    'feedback_for_page': 'Feedback zu dieser Seite?',
    'feedback_received': 'Vielen Dank, wir haben dein Feedback erhalten und kümmern uns umgehend darum.',
    'filter': 'Filter',
    'forever': 'Dauerhaft',
    'format': 'Format',
    'from': 'von',
    'goto_new_version': 'Zur neuen Version.',
    'gross': 'Brutto',
    'imprint': 'Impressum',
    'instead': 'statt',
    'insufficient_permissions': 'Zugriff verweigert',
    'item': 'Produktvorlage | Produktvorlagen',
    'keep': 'Behalten',
    'last_month': 'Letzter Monat',
    'last_week': 'Letze Woche',
    'legal_form': 'Rechtsform',
    'link_copied': 'Link in die Zwischenablage kopiert',
    'list': 'Liste',
    'member': 'Benutzer | Benutzer',
    'menu': 'Menü',
    'message': 'Message',
    'month': 'Monat | Monate',
    'net': 'Netto',
    'new_version': 'Eine neue Version von likvi ist verfügbar',
    'next': 'Weiter',
    'no': 'Kein',
    'ok': 'Ok',
    'open_subscription_settings': 'Abonnement Einstellungen öffnen',
    'optional': 'Optional',
    'options': 'Optionen',
    'other': 'Sonstige',
    'overview': 'Übersicht',
    'page': 'Seite',
    'payment': 'Zahlung | Zahlungen',
    'pdf_inline_not_supported': 'Dein Browser unterstützt keine Inline-PDFs. Du kannst das PDF über den untenstehenden Button herunterladen.',
    'persons_and_companies': 'Personen & Firmen',
    'placeholder': 'Platzhalter | Platzhalter',
    'please_resolve_all_validation_errors': 'Bitte fülle alle benötigten Felder korrekt aus.',
    'preview': 'Vorschau',
    'print': 'Drucken',
    'private': 'Privat',
    'product_name': 'likvi',
    'profile': 'Profil',
    'relative': 'relativ',
    'reload': 'Neu laden',
    'remove': 'Entfernen',
    'required': 'Erforderlich',
    'sales_tax': 'USt.',
    'sales_tax_amount': 'USt. Betrag',
    'sales_tax_rate': 'USt. Satz',
    'save': 'Speichern',
    'search': 'Suche',
    'second': 'Sekunde | Sekunden',
    'selected': 'ausgewählt',
    'send': 'Absenden',
    'send_modal_body': 'Bitte gib die E-Mail Adresse des Empfängers und eine Nachricht ein.',
    'send_modal_successful_title': 'E-Mail wurde gesendet',
    'show_less': 'Weniger anzeigen',
    'show_more': 'Mehr anzeigen',
    'skip': 'Überspringen',
    'status': 'Status',
    'submit': 'Absenden',
    'subscription_expired': 'Dein Abonnement ist ausgelaufen. Bitte wähle einen der folgenden Tarife um unseren Dienst weiterhin zu nutzen.',
    'subscription_expiring': 'Dein Abonnement endet am {subscriptionExpirationDate}. Wenn du unseren Dienst weiterhin nutzen möchtest, setze bitte dein Abonnement in den {settings} fort.',
    'text': 'Text',
    'this_month': 'Dieser Monat',
    'this_week': 'Diese Woche',
    'timeline': 'Timeline',
    'title': 'Titel',
    'to': 'bis',
    'today': 'Heute',
    'tomorrow': 'Morgen',
    'trial_expired': 'Dein Testzeitraum ist ausgelaufen. Bitte wähle einen der folgenden Tarife um unseren Dienst weiterhin zu nutzen.',
    'trial_expiring': 'Dein Testzeitraum endet am {trialExpirationDate}. Bitte hinterlege deine Zahlungsinformationen in den {settings} um unseren Dienst weiterhin nutzen zu können.',
    'unarchive': 'Wiederherstellen',
    'unknown': 'Unbekannt',
    'upload': 'hochladen',
    'vat_number': 'Steuer-IdNr.',
    'view_all': 'Alle anzeigen',
    'view_preview': 'Vorschau anzeigen',
    'warning': 'Warnung',
    'website': 'Webseite',
    'year': 'Jahr',
    'yesterday': 'Gestern',
    'you': 'Du'
  },

  /* english */
  en: {
    'abort': 'Abort',
    'absolute': 'absolute',
    'accept': 'Accept',
    'action': 'Action',
    'active': 'Active',
    'add_textarea': 'Add Textarea',
    'all': 'All',
    'apply': 'apply',
    'archive': 'Archive',
    'archived': 'Archived',
    'authorization_required': 'Please enter your password to authorize the action.',
    'authorize': 'Authorize',
    'auto_generate': 'Auto generate',
    'back': 'Back',
    'cancel': 'Cancel',
    'change_filter_options': 'Please try different filters',
    'change_selection': 'Change Selection',
    'clear': 'Clear',
    'click_to_edit': 'Click to edit',
    'close': 'Close',
    'coming_soon': 'Coming soon',
    'committed': 'Committed',
    'complete': 'Complete',
    'confirm': 'Confirm',
    'contact_support': 'Contact support',
    'copied': 'Copied!',
    'copy': 'Copy',
    'copy_failed': 'Failed to copy to clipboard',
    'create': 'Create',
    'created_at': 'Created',
    'creation_date': 'Creation date',
    'day': 'Day | Days',
    'delete': 'Delete',
    'deleted_user': 'Deleted User',
    'disable': 'Disable',
    'disabled': 'Disabled',
    'display': 'Display',
    'dont_create': 'Don\'t create',
    'download': 'Download',
    'download_pdf': 'Download PDF',
    'duplicate': 'Duplicate',
    'edit': 'Edit',
    'email_to': 'To',
    'enable': 'Enable',
    'enabled': 'Enabled',
    'end': 'End',
    'ends_at': 'Ends at {endsAt}',
    'export': 'Export',
    'export_all': 'Export All',
    'export_selected': 'Export Selected',
    'export_successful_body': 'We will send you an e-mail as soon as the export is completed',
    'export_successful_title': 'Export started',
    'feedback_for_page': 'Feedback for this page?',
    'feedback_received': 'Thank you, we have received your feedback and will get back to you soon.',
    'filter': 'Filter',
    'forever': 'Forever',
    'format': 'Format',
    'from': 'from',
    'goto_new_version': 'Goto new version.',
    'gross': 'Gross',
    'imprint': 'Imprint',
    'instead': 'Instead of',
    'insufficient_permissions': 'Insufficient Permissions',
    'item': 'Article | Articles',
    'keep': 'keep',
    'last_month': 'Last month',
    'last_week': 'Last Week',
    'legal_form': 'Legal Form',
    'link_copied': 'Link copied to clipboard',
    'list': 'List',
    'member': 'Member | Members',
    'menu': 'Menu',
    'message': 'Message',
    'month': 'Month | Months',
    'net': 'Net',
    'new_version': 'A new version of likvi is available',
    'next': 'Next',
    'no': 'No',
    'ok': 'Ok',
    'open_subscription_settings': 'Open Subscription Settings',
    'optional': 'Optional',
    'options': 'Options',
    'other': 'Other',
    'overview': 'Overview',
    'page': 'Page',
    'payment': 'Payment | Payments',
    'pdf_inline_not_supported': 'Your browser does not support inline PDFs. You can download the PDF by clicking the button below..',
    'persons_and_companies': 'Persons & companies',
    'placeholder': 'Placeholder | Placeholders',
    'please_resolve_all_validation_errors': 'Please fill all required fields correctly.',
    'preview': 'preview',
    'print': 'Print',
    'private': 'Private',
    'product_name': 'likvi',
    'profile': 'Profile',
    'relative': 'relative',
    'reload': 'reload',
    'remove': 'Remove',
    'required': 'Required',
    'sales_tax': 'Sales tax',
    'sales_tax_amount': 'Sales Tax Amount',
    'sales_tax_rate': 'Sales Tax Rate',
    'save': 'Save',
    'search': 'Search',
    'second': 'second | seconds',
    'selected': 'selected',
    'send': 'Send',
    'send_modal_body': 'Please enter the the recipient\'s email email address and an message.',
    'send_modal_successful_title': 'Mail has been sent',
    'show_less': 'Show less',
    'show_more': 'Show more',
    'skip': 'Skip',
    'status': 'Status',
    'submit': 'Submit',
    'subscription_expired': 'Your subscription has expired. Please select on of the plans below if you wish to continue using our service.',
    'subscription_expiring': 'Your subscription will end at {subscriptionExpirationDate}. If you wish to continue using our service, please resume your subscription in the {settings}.',
    'text': 'Text',
    'this_month': 'This month',
    'this_week': 'This week',
    'timeline': 'Timeline',
    'title': 'Title',
    'to': 'to',
    'today': 'Today',
    'tomorrow': 'Tomorrow',
    'trial_expired': 'Your trial has expired. Please select one of the plans below if you wish to continue using our service.',
    'trial_expiring': 'Your trial will end at {trialExpirationDate}. Please update your payment information in the {settings} to continue using our service.',
    'unarchive': 'Restore',
    'unknown': 'Unknown',
    'upload': 'upload',
    'vat_number': 'Tax Identification Number',
    'view_all': 'View All',
    'view_preview': 'Show Preview',
    'warning': 'Warning',
    'website': 'Website',
    'year': 'Year',
    'yesterday': 'Yesterday',
    'you': 'You'
  }
}
